/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class dental extends IceEntity {
  dental_key: string = "";
  oral_cavity_designation: string = "";
  prosthesis_crown_inlay_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "DENTAL";
  }
}
